import React from 'react';
import { css } from 'emotion';
import { Button, MaxModal } from '@maxmilhas/hangar-components-atomic/public';

const modalCss = `
  max-width: 400px;

  .title {
    margin: 0 0 12px;
    font-weight: bold;
    color: #223254;
  }

  span {
    opacity: .75;
    font-size: 12px;
    margin-bottom: 12px;
    display: block;
  }
`;

export const ModalError = ({ correlationId, messages, open, onClose }) => {
  return (
    <MaxModal
      open={open}
      onClose={onClose}
      styles={{ modal: { minWidth: 335, zIndex: 99999 } }}
    >
      <div className={css`${modalCss}`}>
        <h2 className="title">Oops!</h2>

        {!messages && (
          <p>
            <strong>Alguma coisa deu errado.</strong> Tente novamente ou contate nosso time de atendimento para solicitar ajuda.
          </p>
        )}

        {messages && typeof messages === 'string' && (
          <p>{messages}</p>
        )}

        {messages && typeof messages !== 'string' && (
          <ul>
            {messages.map(message => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        )}

        {correlationId && (
          <span>Código do erro: {correlationId}</span>
        )}

        <Button size="small" onClick={onClose}>Fechar</Button>
      </div>
    </MaxModal>
  );
};

export default ModalError;
